<template>
    <el-card class="box-card" style="min-width: 120px;">
        <div slot="header" class="clearfix">
            <span>评论增长趋势</span>
            <el-radio-group style="float: right;position: relative;top: -3px;" v-model="checkbox" size="mini" @change="change">
                <el-radio-button label="月"></el-radio-button>
                <el-radio-button label="年"></el-radio-button>
            </el-radio-group>
        </div>
        <div id="increase" style="min-width:400px;height:400px"></div>
    </el-card>
</template>

<script>
import * as echarts from "echarts";
export default {
    data() {
        return {
            option: {},
            checkbox: "月",
            myChart: null
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        screenWidth() {
            this.myChart.resize();
        },
        change() {
            if (this.checkbox == "年") {
                this.getData_M();
            } else {
                this.getData();
            }
        },
        getData() {
            let date = [
                "2019-08",
                "2019-09",
                "2019-10",
                "2019-11",
                "2019-12",
                "2020-01",
                "2020-02",
                "2020-03",
                "2020-04",
                "2020-05",
                "2020-06",
                "2020-07",
                "2020-08",
                "2020-09",
                "2020-10",
                "2020-11",
                "2020-12",
                "2021-01",
                "2021-02",
                "2021-03",
                "2021-04",
                "2021-05",
                "2021-06",
                "2021-07",
                "2021-08"
            ];
            let data = [
                0,
                1,
                3,
                2,
                2,
                10,
                15,
                55,
                14,
                75,
                45,
                62,
                1,
                4,
                5,
                48,
                65,
                52,
                11,
                45,
                42,
                1,
                0,
                44
            ];
            let data1 = [
                null,
                null,
                null,
                null,
                0,
                -100,
                100,
                -100,
                100,
                -100,
                5000,
                -100,
                100,
                -100,
                100,
                -100,
                100,
                -100,
                -100,
                null,
                null,
                null,
                null,
                null
            ];
            this.viewCharts(date, data, data1);
        },
        getData_M() {
            this.option.xAxis.data = ["2019", "2020", "2021"];
            this.option.series[0].data = ["125", "255", "89"];
            this.option.series[1].data = [500, 900, 200];
            this.myChart.setOption(this.option);
        },
        viewCharts(date, data, data1) {
            this.myChart = echarts.init(document.getElementById("increase"));
            this.option = {
                tooltip: {
                    trigger: "axis",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    borderColor: "rgba(0, 0, 0, 0.6)",
                    textStyle: {
                        color: "rgb(255, 255, 255)"
                    },
                    formatter: function(params) {
                        var htmlStr = "";
                        for (var i = 0; i < params.length; i++) {
                            var param = params[i];
                            var xName = param.name;
                            var seriesName = param.seriesName;
                            var value = param.value;
                            var color = param.color;
                            if (i === 0) {
                                htmlStr += xName + "<br/>";
                            }
                            htmlStr += "<div>";
                            //为了保证和原来的效果一样，这里自己实现了一个点的效果
                            htmlStr +=
                                "<span style='margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:" +
                                color +
                                ";'></span>";
                            if (seriesName == "增长率") {
                                let str = value == null ? "--" : value;
                                htmlStr += seriesName + "：" + str + "%";
                            } else {
                                htmlStr += seriesName + "：" + value;
                            }
                            htmlStr += "</div>";
                        }
                        return htmlStr;
                    }
                },
                dataZoom: [
                    {
                        type: "inside",
                        start: 0,
                        end: 100
                    },
                    {
                        start: 0,
                        end: 100
                    }
                ],
                grid: {
                    left: "1.5%",
                    right: "1.5%",
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    data: date
                },
                legend: {
                    data: ["新增评论数", "增长率"]
                },
                yAxis: [
                    {
                        type: "value",
                        name: "新增评论数",
                        min: 0
                    },
                    {
                        type: "value",
                        name: "增长率",
                        axisLabel: {
                            formatter: "{value} %"
                        }
                    }
                ],
                series: [
                    {
                        name: "新增评论数",
                        type: "bar",
                        data: data,
                        showAllSymbol: false,
                        barWidth: 25,
                        itemStyle: {
                            color: "rgb(128, 157, 173)",
                            borderRadius: [4, 4, 0, 0]
                        },
                        lineStyle: {
                            color: "rgb(128, 157, 173)"
                        },
                        emphasis: {
                            lineStyle: {
                                width: 2
                            }
                        }
                    },
                    {
                        name: "增长率",
                        type: "line",
                        data: data1,
                        yAxisIndex: 1,
                        showAllSymbol: false,
                        smooth: true,
                        itemStyle: {
                            color: "rgb(204, 44, 35)"
                        },
                        lineStyle: {
                            color: "rgb(204, 44, 35)"
                        },
                        emphasis: {
                            lineStyle: {
                                width: 2
                            }
                        }
                    }
                ]
            };
            // 绘制图表
            this.myChart.setOption(this.option);
        }
    }
};
</script>

<style type="text/scss" lang="scss" scoped>
</style>
